import {StyleFormat} from '~/src/utilities/feed/format';

interface TeaserContent {
    embedUrl?: string;
    useEmbedUrl?: boolean;
    styles?: {
        name?: string;
    };
    title?: string;
}

export interface Teaser {
    type: string;
    id?: number;
    content?: TeaserContent;
    availableFor?: {
        app?: boolean;
        desktop?: boolean;
        mobileWeb?: boolean;
    };
    adUnitName?: string;
    forcePosition?: string;
    isCrassAd?: boolean;
    sortID: number;
    format?: StyleFormat;
}

/**
 * Check if an element has an embedURL and transforms it into an iframe.
 * No transformations are done if it doesn't contain an embedURL
 *
 * @param {object} element feed element data to transform
 * @returns transformed data or the original element
 */
export const transformIframe = (element: Teaser) => {
    const useEmbedUrl = element.content?.useEmbedUrl || false;
    const style = element.content?.styles?.name?.toLowerCase() || 'default';

    if (useEmbedUrl && style === 'fullformat') {
        return {
            type: 'iframe',
            id: element.id,
            src: element.content?.embedUrl || '',
            title: element.content?.title || ''
        };
    }

    return element;
};

/**
 * Go through all elements and sanitize its styles attribute
 *
 * @param {object} element feed element data to transform
 * @returns transformed data or the original element
 */
export const sanitizeStyles = (element: Teaser) => {
    if (element.content?.styles?.name) {
        element.content.styles.name = element.content.styles.name.toLowerCase();
    }
    return element;
};
